var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emoji-code",class:'emoji-code-' + _vm.type},[(_vm.intCode > 0)?_c('img',{attrs:{"alt":_vm.alt,"aria-label":_vm.ariaLabel,"src":_vm.emojis[_vm.intCode - 1],"title":_vm.alt}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }